import { CreateDataAttribute } from "@/api/sanity/nextSanity";
import { BannerContent, BannerGridData, LivePreviewProps, TranslationData } from "@/common/lib/types";
import { useMemo } from "react";
import { pageSections } from "@/apiUtils/constants";
import { getLangFromLocale } from "@/utils/common";
import BannerGrid from "../common/BannerGrid/BannerGrid";

interface IProps {
  categoryBanner: BannerContent;
  brandBanner: BannerContent;
  productBanner: BannerContent;
  collectionBanner: BannerContent;
  locale: string;
  translations?: TranslationData;
  categoryLivePreviewMapper?: CreateDataAttribute<LivePreviewProps>;
  brandLivePreviewMapper?: CreateDataAttribute<LivePreviewProps>;
  collectionLivePreviewMapper?: CreateDataAttribute<LivePreviewProps>;
  productLivePreviewMapper?: CreateDataAttribute<LivePreviewProps>;
}

const PdpBanner = ({
  brandBanner,
  categoryBanner,
  collectionBanner,
  locale,
  productBanner,
  translations,
  brandLivePreviewMapper,
  categoryLivePreviewMapper,
  collectionLivePreviewMapper,
  productLivePreviewMapper,
}: IProps) => {
  const lang = getLangFromLocale(locale);
  const sortedBanners = useMemo(() => {
    const banners = [];
    if (brandBanner) {
      banners.push({ banner: brandBanner, livePreviewMapper: brandLivePreviewMapper });
    }
    if (categoryBanner) {
      banners.push({ banner: categoryBanner, livePreviewMapper: categoryLivePreviewMapper });
    }
    if (collectionBanner && (!brandBanner || !categoryBanner || !productBanner)) {
      banners.push({ banner: collectionBanner, livePreviewMapper: collectionLivePreviewMapper });
    }
    if (productBanner) {
      banners.push({ banner: productBanner, livePreviewMapper: productLivePreviewMapper });
    }
    return banners;
  }, [
    brandBanner,
    brandLivePreviewMapper,
    categoryBanner,
    categoryLivePreviewMapper,
    collectionBanner,
    collectionLivePreviewMapper,
    productBanner,
    productLivePreviewMapper,
  ]);

  const transformedBannerData = useMemo(() => {
    return {
      key: "",
      type: pageSections.BANNER_GRID,
      items: sortedBanners.map((item, idx) => {
        return {
          bannerType: item?.banner?.type,
          key: `${idx}`,
          mediaTile: {
            media: {
              largeMediaUrl: item?.banner?.media?.desktop?.[lang],
              smallMediaUrl: item?.banner?.media?.mobile?.[lang],
            },
            videoThumbnail: {
              largeMediaUrl: item?.banner?.media?.desktop?.thumbnail?.[lang],
              smallMediaUrl: item?.banner?.media?.mobile?.thumbnail?.[lang],
            },
            loop: item?.banner?.media?.loop,
            showControls: item?.banner?.media?.showControls,
            mediaType: item?.banner?.mediaType,
          },
          type: "",
          contentTile: {
            richText: item?.banner?.info?.[lang],
            link: item?.banner?.link,
          },
        };
      }),
    } as BannerGridData;
  }, [sortedBanners.length]);

  // console.log({ transformedBannerData });

  return transformedBannerData.items.length > 0 ? (
    <div className="mt-24">
      <BannerGrid content={transformedBannerData} isPDP={true} translations={translations} />
    </div>
  ) : (
    <></>
  );
};

export default PdpBanner;
